export function withStatusOrder(loanStatusData) {
    const statusKeys = Object.keys(loanStatusData);
    for (let i = 0; i < statusKeys.length; i++) {
        loanStatusData[statusKeys[i]].order = i + 1;
    }
    return loanStatusData;
}
